import { Controller } from "@hotwired/stimulus";

// Centre d'aide : filtre les questions pendant la frappe et surligne les mots trouvés,
// sans tenir compte des accents ni de la casse (« reseaux » trouve « réseaux »).
export default class extends Controller {
  static targets = ["input", "section", "article", "navItem", "empty"];
  static classes = ["mark"];

  connect() {
    this.articleTargets.forEach((article) => {
      article.querySelectorAll("[data-help-search-text]").forEach((el) => {
        el.dataset.original = el.innerHTML;
      });
    });
    if (this.inputTarget.value) this.filter();
  }

  filter() {
    const query = this.normalize(this.inputTarget.value.trim());
    let visibleTotal = 0;

    this.sectionTargets.forEach((section) => {
      let visible = 0;
      section.querySelectorAll("[data-help-search-target='article']").forEach((article) => {
        const match = !query || this.normalize(article.textContent).includes(query);
        article.hidden = !match;
        article.open = Boolean(query) && match;
        this.highlight(article, match ? query : "");
        if (match) visible += 1;
      });
      section.hidden = visible === 0;
      this.navItemTargets
        .filter((item) => item.dataset.section === section.id)
        .forEach((item) => {
          item.hidden = visible === 0;
          const count = item.querySelector("[data-help-search-count]");
          if (count) count.textContent = visible;
        });
      visibleTotal += visible;
    });

    if (this.hasEmptyTarget) this.emptyTarget.hidden = visibleTotal > 0;
  }

  highlight(article, query) {
    article.querySelectorAll("[data-help-search-text]").forEach((el) => {
      el.innerHTML = el.dataset.original;
      if (query) this.markTextNodes(el, query);
    });
  }

  // Parcourt les nœuds texte : le HTML de la réponse (paragraphes, liens) reste intact.
  markTextNodes(root, query) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const text = node.nodeValue;
      const normalized = this.normalize(text);
      let index = normalized.indexOf(query);
      if (index < 0) return;

      const fragment = document.createDocumentFragment();
      let cursor = 0;
      while (index >= 0) {
        fragment.append(text.slice(cursor, index));
        const mark = document.createElement("mark");
        mark.className = this.markClasses.join(" ");
        mark.textContent = text.slice(index, index + query.length);
        fragment.append(mark);
        cursor = index + query.length;
        index = normalized.indexOf(query, cursor);
      }
      fragment.append(text.slice(cursor));
      node.replaceWith(fragment);
    });
  }

  // Une lettre accentuée devient une seule lettre : les positions restent alignées sur le texte d'origine.
  normalize(text) {
    return text.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/’/g, "'");
  }
}
